var $b7022d15468f3c43$exports = {};
$b7022d15468f3c43$exports = {
    "info": `Inform\u{101}cija`,
    "negative": `K\u{13C}\u{16B}da`,
    "positive": `Izdev\u{101}s`
};


export {$b7022d15468f3c43$exports as default};
//# sourceMappingURL=lv-LV.mjs.map
